/**
 * SyntaxHighlighterLanguages
 * Enum of languages supported by SyntaxHighlighter
 */
export enum SyntaxHighlighterLanguages {
    bash = "bash",
    python = "python",
    typescript = "typescript",
    javascript = "javascript",
}
